import ds, {dsc, ___} from '../utils/daoService/DaoServiceClientES6Adapter'

const ebCtnRequest = ds.QEbCtnRequest.using(dsc)

// 通过ebOrderId查询
ebCtnRequest.getEbCtnRequestByEbOrderId = function (ebOrderId) {
  return ebCtnRequest
    .select(ebCtnRequest.fieldContainer())
    .where(ebCtnRequest.ebOrderId.eq$(ebOrderId))
    .tag('getEbCtnRequestByEbOrderId')
    .execute()
}

// 批量删除
ebCtnRequest.batchDelete = function (ebCtnRequestIds) {
  return ebCtnRequest.deleteById(ebCtnRequestIds)
}
export default ebCtnRequest
